import React, {Component} from 'react';
import { localize } from 'react-localize-redux';
import { GoogleMap, Polyline, Marker, withGoogleMap, withScriptjs } from 'react-google-maps';
import $ from 'jquery';

import mapPin from 'Content/Assets/images/maps/map-marker_100.png';
import carPin from 'Content/Assets/images/maps/car_50.png';
import GoogleInfoBox from 'components/maps/GoogleInfoBox';
import * as miscServices from 'services/miscServices';
import * as mapsServices from 'services/maps/googleMapControlsServices';
import 'containers/maps/styles/GoogleMapSpeedPinList.css';

const { InfoWindow } = require("react-google-maps");

/**
 * carica uno o più pin
 */
class GoogleMapSpeedPinList extends Component {

    constructor(props){
        super(props)

        this.onToggleOpenMarkerInfoWindow = this.onToggleOpenMarkerInfoWindow.bind(this);
        this.onToggleOpenMainInfoWindow = this.onToggleOpenMainInfoWindow.bind(this);
        this.createSpeedColorList = this.createSpeedColorList.bind(this);
        this.getColorFromSpeedList = this.getColorFromSpeedList.bind(this);
        this.getPolyLineList = this.getPolyLineList.bind(this);
        this.getMarker = this.getMarker.bind(this);
        this.getMidPoint = this.getMidPoint.bind(this);

        var coords = [];
        /*
            attenzione! per utilizzare le librerie native di google ho due strade
            1- aggiungere il link nella pagina index.html
            2- utilizzare HOC withScriptjs

            e per poterle utilizzare bisogna dichiarare
            const google = window.google;
        */

        var zoom = props.zoom;
        var polyLineList;

        if(!zoom)
        {
            zoom = 12;
        }

        const getMidPoint = this.getMidPoint;
        if(props.pinList){
            var colorSpeedList = this.createSpeedColorList(props.pinList);

            var previous;
            $.each(props.pinList, function (index, item) {
                if(item.position.lat === 0 || item.position.lng === 0)
                {
                    return;
                }

                if(!previous)
                {
                    previous = { lat: item.position.lat, lng: item.position.lng}
                    coords.push(previous);
                    return;
                }

                var current = { lat: item.position.lat, lng: item.position.lng};
                /*-
                    calcolo i punti tra il previous e il current
                */
                var midpoint = getMidPoint(previous.lat, previous.lng, current.lat, current.lng);
                coords.push(midpoint);
                coords.push(current);
                previous = current;

            });

            polyLineList = this.getPolyLineList(colorSpeedList, props.pinList);
        }

        var movingMarkerPosition;

        if(coords && coords.length > 0)
        {
            movingMarkerPosition = coords[0];
        }

        this.state = {
            isOpenMainInfoWindow: false,
            polyLineList,
            coords,
            zoom,
            singlePinInfoWindowPosition: '',
            movingMarkerPosition,
            currentCount : 0,
            colorSpeedList: colorSpeedList
        };

    }

    getMidPoint($lat1, $lng1, $lat2, $lng2) {
        $lat1 = $lat1 * 0.017453292519943295;
        $lng1 = $lng1 * 0.017453292519943295;
        $lat2 = $lat2 * 0.017453292519943295;
        $lng2 = $lng2 * 0.017453292519943295;

        var $dlng = $lng2 - $lng1;
        var $Bx = Math.cos($lat2) * Math.cos($dlng);
        var $By = Math.cos($lat2) * Math.sin($dlng);
        var $lat3 = Math.atan2( Math.sin($lat1)+Math.sin($lat2),
        Math.sqrt((Math.cos($lat1)+$Bx)*(Math.cos($lat1)+$Bx) + $By*$By ));
        var $lng3 = $lng1 + Math.atan2($By, (Math.cos($lat1) + $Bx));
        var $pi = 3.141592653589793;
        var $lat = ($lat3*180)/$pi;
        var $lng = ($lng3*180)/$pi;
        return {lat: $lat, lng: $lng};
    }

    timer() {

        var {movingMarkerPosition, coords} = this.state;

        if(movingMarkerPosition === null)
        {
            /*
                prima posizione
            */
            this.setState({
                movingMarkerPosition: coords[0]
            })
            /*
                blocco subito per far partire un altro ciclo
            */
            clearInterval(this.intervalId);
            return;
        }
        else {
            /*
                cerco il movingMarkerPosition tra le coords, se il corrente
                è l'ultimo allora si ricomincia dal primo
            */
            var found;
            var foundIndex;
            $.each(coords, function (index, item){
                if(item.lat === movingMarkerPosition.lat && item.lng === movingMarkerPosition.lng)
                {
                    found = item;
                    foundIndex = index;
                    return;
                }
            });

            if(!found)
            {
                /*
                    qualocosa è andato storto, fermo tutto
                */
                clearInterval(this.intervalId);
                return;
            }

            if(foundIndex === coords.length - 1)
            {
                this.setState({
                    movingMarkerPosition: coords[0]
                })
                return;
            }
            else{
                /*
                    sposto il marker alla posizione successiva
                */
                this.setState({
                    movingMarkerPosition: coords[foundIndex + 1]
                })
                return;
            }
        }
    }

    /**
     * blocco timer del pin in movimento
     */
    componentWillUnmount(){
        clearInterval(this.intervalId);
    }

    componentDidMount(){

        if(!this.map) return;
        if(!this.state.coords) return;
        if(this.state.coords.length <= 0) return;

        this.intervalId = setInterval(this.timer.bind(this), 200);

        const google = window.google;

        var bounds = new google.maps.LatLngBounds();
        var path = [];
        $.each(this.state.coords, function (index, item){
            var loc = new google.maps.LatLng(item.lat,item.lng );
            path.push(loc);
            bounds.extend(loc);
        });

        // auto zoom
        this.map.fitBounds(bounds)
        //auto-center
        this.map.panToBounds(bounds);

        /*
            aggiungo controlli custom: center page e speed legend
        */
       mapsServices.createCenterControl(this.props.translate, this.map.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, this.props.centerPosition);

       mapsServices.createSpeedLegendControl(this.props.translate, this.map.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, this.state.colorSpeedList, this.props.unitOfMeaserLabel);
    }

    onToggleOpenMarkerInfoWindow(marker){

        if(!this.state.singlePinInfoWindowPosition)
        {
            this.setState({
                singlePinInfoWindowPosition: marker.name
            });
            return;
        }

        if(this.state.singlePinInfoWindowPosition === marker.name)
        {
            /*
                lo chiudo
            */
            this.setState({
                singlePinInfoWindowPosition: ''
            });
            return;
        }

        /*
            apro infowindow su altro marker
        */
        this.setState({
            singlePinInfoWindowPosition:  marker.name
        });
        return;
    }


    /**
     * gestisce la chiusura o apertura dell'info windows del pin
    */
    onToggleOpenMainInfoWindow(){
        this.setState({
            isOpenMainInfoWindow: !this.state.isOpenMainInfoWindow
        });
    }

    createSpeedColorList(pinList){
        if(!pinList) return null;
        if(!pinList.length) return null;

        /*
            prima creo la lista delle velocità senza colore
            poi ordino per velocità e assegno il colore in modo incrementale dal rosso al verde
        */
        var colorSpeedList = [];

        $.each(pinList, function (index, item) {

            if(item.position.lat === 0 || item.position.lng === 0)
            {
                return;
            }

            /*
                item.speed è già stato convertito in km/h o miph
            */

            if (colorSpeedList.length === 0) {
                // primo elemento
                colorSpeedList.push({ speed: item.speed, position: item.position, color: null });
                // continue;
                return;
            }
            var found;

            $.each(colorSpeedList, function (index, colorItem){
                if(colorItem.speed === item.speed){
                    found = true;
                    return;
                }
            });

            if(!found)
            {
                // se non esiste lo aggiungo
                colorSpeedList.push({ speed: item.speed, position: item.position, color: null });
            }
        });

        /*
            ordino la lista per speed
        */
        colorSpeedList = colorSpeedList.sort(function(a,b)
        {
            if(a.speed < b.speed) return -1;
            if(a.speed > b.speed) return 1;
            return -1;
        });

        /**
        * dal verde #1E9037 al rosso #C11718, il verde è la velocità più bassa, il rosso quella più alta, il giallo la velocità di mezzo (dovrebbe essere automatico)
        */
        var green = "#1E9037";
        var red = "#C11718";

        var gradients = [];

        /*
            in mezzo ci metto il giallo altrimenti ci mette un rosso color cacca
        */
        var totalColors = colorSpeedList.length;

        if (colorSpeedList.length > 2) {
            // chiamo il reverse perchè il numberToColorHsl comincia col il verde e finisce col rosso
            $.each(colorSpeedList.reverse(), function (index, point) {
                if (index === 0) {
                    gradients.push(miscServices.numberToColorHsl(0));
                } else {
                    var percent = ((index + 1) * 100) / totalColors;
                    gradients.push(miscServices.numberToColorHsl(percent));
                }
            });

        } else if(colorSpeedList.length === 2){
            gradients.push(green);
            gradients.push(red);
        }
        else{
            gradients.push(green);
        }

        if(colorSpeedList.length > 0)
        {
            $.each(gradients, function (index, item) {
                colorSpeedList[index].color = item;
            });
        }

        return colorSpeedList;
    }

    getColorFromSpeedList(speedValue, list) {
        if(!list) return null;
        if(!list.length) return null;

        var found;
        $.each(list, function (index, item){
            if(item.speed === speedValue){
                found = item;
                return;
            }
        });

        if(found) return found.color;
        return null;
    }

    /**
     * crea una lista di polyline con settaggio, ognuno con un colore differente in base alla
     */
    getPolyLineList(colorSpeedList, pinList){
        if(!pinList) return null;
        if(!pinList.length) return null;
        if(!colorSpeedList) return null;
        if(!colorSpeedList.length) return null;
        /*
            creo una nuova polyline appena cambia velocità
        */
        var list = [];
        var previous = null;
        var color = null;
        var polyLine = null;
        const getColorFromSpeedList = this.getColorFromSpeedList;

        $.each(pinList, function (index, item){

            if(!previous)
            {
                /*
                    primo elemento della lista
                */
                color = getColorFromSpeedList(item.speed, colorSpeedList);
                if (!color) {
                    color = "#C11718";
                }

                polyLine = {
                    path: [],
                    color: color,
                    speed: item.speed,
                    name: item.name,
                    options: {
                        geodesic: true,
                        strokeColor: color,
                        strokeOpacity: 1.0,
                        strokeWeight: 6
                    }
                }

                polyLine.path.push({lat: item.position.lat, lng: item.position.lng});

                previous = polyLine;
                list.push(polyLine);
                return;
            }

            if(previous.speed === item.speed)
            {
                /*
                    non creo un nuovo polyline con un nuovo colore ma aggiungo questo item
                    al suo path
                */
                previous.path.push({lat: item.position.lat, lng: item.position.lng});
                return;
            }

            /*
                aggiungo questa posizione per terminare la line precedente o
                mi trovo un buco
            */
            previous.path.push({lat: item.position.lat, lng: item.position.lng});

            /*
                velocità cambiata! creo un nuovo polyline
            */

            color = getColorFromSpeedList(item.speed, colorSpeedList);
            if (!color) {
                color = "#C11718";
            }

            polyLine = {
                path: [],
                color: color,
                name: item.name,
                speed: item.speed,
                options: {
                    geodesic: true,
                    strokeColor: color,
                    strokeOpacity: 1.0,
                    strokeWeight: 6
                }
            }

            polyLine.path.push({lat: item.position.lat, lng: item.position.lng});

            previous = polyLine;
            list.push(polyLine);

        });

        return list;
    }

    getMarker(pin, key){
        if(!pin) return null;
        if(!pin.showPin) return null;

        var {singlePinInfoWindowPosition} = this.state;

        var {translate, dateTime, addres, icnPlus, isMilesPerHour, unitOfMeaserLabel,
            pdof } = this.props;

        /*
            il pin non-incidente ha un infowindow differente
        */
        if(!pin.isIncidentPin)
        {
            return <Marker
                key={key}
                position={pin.position}
                onClick={ () => { if(pin.showInfoWindow) this.onToggleOpenMarkerInfoWindow(pin); }}
                icon={
                    pin.icon
                }>
                {
                    pin.showInfoWindow
                    && singlePinInfoWindowPosition === pin.name
                    &&
                    <InfoWindow onCloseClick={ () => { if(pin.showInfoWindow) this.onToggleOpenMarkerInfoWindow(pin); }}>
                        <GoogleInfoBox translate={translate} position={pin.position}
                            speed={pin.speed} unitOfMeaserLabel={unitOfMeaserLabel} />
                    </InfoWindow>
                }
            </Marker>
        }

        return <Marker
            icon={mapPin}
            key={key}
            position={pin.position}
            onClick={ () => { this.onToggleOpenMarkerInfoWindow(pin); }}
            >
            {   singlePinInfoWindowPosition === pin.name
                &&
                    <InfoWindow onCloseClick={ () => { this.onToggleOpenMarkerInfoWindow(pin); }} >
                        <GoogleInfoBox translate={translate} dateTime={dateTime} position={pin.position}
                            icnPlus={icnPlus} addres={addres} isMilesPerHour={isMilesPerHour}
                            speed={pin.speed} unitOfMeaserLabel={unitOfMeaserLabel} pdof={pdof} />
                    </InfoWindow>
            }
        </Marker>

    }

    render() {
        console.info("google map speed ping list rendered");
        var {translate, position, isMarkerShown, dateTime, addres, icnPlus, isMilesPerHour, speed, unitOfMeaserLabel,
            pdof, pinList, showPolyLine } = this.props;

        var {isOpenMainInfoWindow, polyLineList, zoom, movingMarkerPosition} = this.state;

        return (
            <div>
            <GoogleMap
                ref={(ref) => { this.map = ref; }}
                defaultZoom={zoom}
                defaultOptions={
                    {
                        gestureHandling: 'greedy'
                    }
                }
                defaultCenter={ position }>
                {
                    isMarkerShown && position &&
                    <Marker
                        icon={mapPin}
                        position={ position}
                        onClick={this.onToggleOpenMainInfoWindow}
                        >
                        {isOpenMainInfoWindow &&
                                <InfoWindow onCloseClick={this.onToggleOpenMainInfoWindow} >
                                    <GoogleInfoBox translate={translate} dateTime={dateTime} position={position}
                                        icnPlus={icnPlus} addres={addres} isMilesPerHour={isMilesPerHour}
                                        preCrashSpeed={speed} unitOfMeaserLabel={unitOfMeaserLabel} pdof={pdof} />
                                </InfoWindow>
                        }
                    </Marker>
                }
                {
                    movingMarkerPosition ?
                    <Marker
                        icon={carPin}
                        position={ movingMarkerPosition}
                        >
                    </Marker>
                    : null
                }
                {
                    pinList && pinList.length > 0 ?
                    pinList.map((pin, key) => (
                        this.getMarker(pin, key)
                        ))
                    : null
                }
                {
                    showPolyLine &&
                    polyLineList.map((item, key) => (
                        <Polyline path={item.path} options={item.options} key={key} />

                        ))
                }
            </GoogleMap>
            </div>
        );
    }
}

export default withScriptjs(withGoogleMap(localize(GoogleMapSpeedPinList, 'locale')));


// WEBPACK FOOTER //
// ./src/containers/maps/GoogleMapSpeedPinList.js